module.exports = __webpack_public_path__ + "img/k23y-l6-j.prt.45e69a96.jpg";